(function () {
  'use strict';

  var STORAGE_KEY = 'ils_recently_viewed';
  var MAX_STORED = 12;
  var MAX_SHOWN = 8;
  /* TASK-2986 — button label, overridden per-locale from the section's
     data-ils-rv-details-label attribute (see custom-main-product.liquid). */
  var DETAILS_LABEL = 'Product details';

  /* TASK-2984 — locale-aware "Recently viewed".
     The block used to STORE the full localized product object (title/url/
     images) captured at the moment of viewing, then RENDER straight from that
     cache. So a product first seen on LV was shown with its Latvian title even
     on a RU-LV page. Fix: store only the locale-STABLE numeric product id (+
     the handle as a hint), and re-resolve every displayed field (title, url,
     images) in the CURRENT locale at render time. Resolution order:
       1) /{locale}/products/{stored-handle}.js  — a cheap hit when the stored
          handle already belongs to the current locale (same-locale revisit).
          It ONLY 200s when the handle exists in that locale, so a 200 is
          always current-locale-correct.
       2) /{locale}/products.json (paged, cached per-locale for the session)
          matched by the stable numeric id — covers the cross-locale case and
          is always rendered in the current locale regardless of stored handle.
     We never follow product HTML redirects (those can cross into another
     market on the primary root), so the language shown always matches the
     page the shopper is on right now. */

  /* Locale root helper — mirror of custom-cart-drawer.js. Yields '' on the
     primary storefront or e.g. '/ru-lv' on a localized one. */
  var ILS_KNOWN_LOCALE_PREFIXES = [
    '/en-eu', '/ru-eu',
    '/de-de', '/ru-de',
    '/lv-lv', '/ru-lv',
    '/et-ee', '/ru-ee',
    '/lt-lt', '/ru-lt'
  ];
  function localeRoot() {
    try {
      var r = window.Shopify && Shopify.routes && Shopify.routes.root;
      if (typeof r === 'string' && r.length > 0) {
        var trimmed = r.replace(/\/+$/, '');
        return trimmed === '' ? '' : trimmed;
      }
    } catch (e) {}
    var path = (window.location && location.pathname) || '';
    for (var i = 0; i < ILS_KNOWN_LOCALE_PREFIXES.length; i++) {
      var pfx = ILS_KNOWN_LOCALE_PREFIXES[i];
      if (path === pfx || path.indexOf(pfx + '/') === 0) return pfx;
    }
    return '';
  }

  function readHistory() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeHistory(arr) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {}
  }

  function handleFromUrl(url) {
    if (!url) return '';
    try {
      var path = String(url).split('?')[0].split('#')[0];
      var m = path.match(/\/products\/([^\/]+)\/?$/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }

  /* Store ONLY the locale-stable id (+ handle hint). No title/images/url —
     those are what leaked the old language. */
  function recordCurrent() {
    var el = document.querySelector('[data-ils-rv-current]');
    if (!el) return;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return; }
    if (!data || data.id == null) return;

    var rec = { id: data.id, handle: data.handle || handleFromUrl(data.url) || null };

    var hist = readHistory();
    hist = hist.filter(function (p) { return String(p.id) !== String(data.id); });
    hist.unshift(rec);
    if (hist.length > MAX_STORED) hist = hist.slice(0, MAX_STORED);
    writeHistory(hist);
  }

  /* ---- current-locale product resolution ---- */

  function sizedImg(src) {
    if (!src) return src;
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=360';
  }

  function fetchJs(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { return (p && p.id != null) ? p : null; })
      .catch(function () { return null; });
  }

  /* Per-locale catalog, cached in sessionStorage. Compact map: id -> {t,h,i}.
     Only fetched (once per locale per session) when a cross-locale lookup
     actually needs it. */
  var _catalogPromise = null;
  function catalogCacheKey() { return 'ils_rv_catalog_' + (localeRoot() || 'root'); }

  function fetchCatalog() {
    if (_catalogPromise) return _catalogPromise;
    var key = catalogCacheKey();
    try {
      var cached = sessionStorage.getItem(key);
      if (cached) {
        var obj = JSON.parse(cached);
        if (obj && obj.map) { _catalogPromise = Promise.resolve(obj.map); return _catalogPromise; }
      }
    } catch (e) {}

    var root = localeRoot();
    var LIMIT = 250;
    var map = {};
    function page(n) {
      var url = root + '/products.json?limit=' + LIMIT + '&page=' + n;
      return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var arr = data && data.products;
          if (!Array.isArray(arr) || !arr.length) return map;
          arr.forEach(function (p) {
            map[String(p.id)] = {
              t: p.title,
              h: p.handle,
              i: (p.images || []).map(function (im) { return sizedImg(im.src); })
            };
          });
          if (arr.length < LIMIT || n >= 10) return map; // stop / safety cap
          return page(n + 1);
        });
    }

    _catalogPromise = page(1).then(function (m) {
      try { sessionStorage.setItem(key, JSON.stringify({ map: m })); } catch (e) {}
      return m;
    }).catch(function () { return map; });
    return _catalogPromise;
  }

  function normFromJs(p) {
    return {
      title: p.title,
      url: p.url || (localeRoot() + '/products/' + p.handle),
      images: (p.images || []).map(sizedImg)
    };
  }
  function normFromCatalog(rec) {
    if (!rec) return null;
    return {
      title: rec.t,
      url: localeRoot() + '/products/' + rec.h,
      images: Array.isArray(rec.i) ? rec.i : []
    };
  }

  /* Resolve one stored entry to a current-locale card model, or null. */
  function resolveProduct(entry) {
    var handle = entry.handle || handleFromUrl(entry.url);
    var root = localeRoot();
    var fast = handle
      ? fetchJs(root + '/products/' + encodeURIComponent(handle) + '.js')
      : Promise.resolve(null);
    return fast.then(function (p) {
      if (p) return normFromJs(p);           // stored handle already in this locale
      return fetchCatalog().then(function (map) {  // cross-locale → look up by id
        return normFromCatalog(map[String(entry.id)]);
      });
    }).catch(function () { return null; });
  }

  /* ---- card markup / carousel (unchanged behavior) ---- */

  function slideMarkup(images, idx) {
    var img = images[idx];
    return (
      '<div class="ils-pcm__slide' + (idx === 0 ? ' is-on' : '') + '" data-idx="' + idx + '">' +
        '<img src="' + img + '" loading="lazy" alt="">' +
      '</div>'
    );
  }

  /* TASK-2050 (owner report) — use ALL of the product's images (matches
     the collection card / product-rail pip behavior), not just the
     first 3. Pip count == real image count; active pip renders as a
     pill (.is-on, styled in CSS to grow into a bar), same as every
     other product-photo carousel on the site. */
  function cardMarkup(p) {
    var images = Array.isArray(p.images) && p.images.length ? p.images : (p.image ? [p.image] : []);
    var slidesHtml = '';
    var pipsHtml = '';
    if (images.length) {
      images.forEach(function (img, i) { slidesHtml += slideMarkup(images, i); });
      if (images.length > 1) {
        images.forEach(function (_, i) {
          pipsHtml += '<span class="ils-pcm__pip' + (i === 0 ? ' is-on' : '') + '"></span>';
        });
      }
    }
    var imgBlock = images.length
      ? '<div class="ils-pcm__slides" data-ils-pcm-slides>' + slidesHtml + '</div>' +
        (images.length > 1 ? '<div class="ils-pcm__pips" aria-hidden="true">' + pipsHtml + '</div>' : '')
      : '<div class="ils-pcm__placeholder"></div>';

    return (
      '<div class="ils-rv__item">' +
        '<article class="ils-pcm">' +
          '<a class="ils-pcm__imgwrap" href="' + p.url + '" aria-label="' + escapeHtml(p.title) + '">' +
            imgBlock +
          '</a>' +
          '<div class="ils-pcm__body">' +
            '<a class="ils-pcm__name" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
            '<a class="ils-pcm__btn" href="' + p.url + '">' + escapeHtml(DETAILS_LABEL) + '</a>' +
          '</div>' +
        '</article>' +
      '</div>'
    );
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var autoplayTimer = null;
  function startAutoplay(root) {
    if (autoplayTimer) clearInterval(autoplayTimer);
    autoplayTimer = setInterval(function () {
      root.querySelectorAll('[data-ils-pcm-slides]').forEach(function (slides) {
        var imgs = slides.querySelectorAll('.ils-pcm__slide');
        if (imgs.length < 2) return;
        var cur = 0;
        imgs.forEach(function (s, i) { if (s.classList.contains('is-on')) cur = i; });
        var nxt = (cur + 1) % imgs.length;
        imgs[cur].classList.remove('is-on');
        imgs[nxt].classList.add('is-on');
        var card = slides.closest('.ils-pcm');
        if (card) {
          var pips = card.querySelectorAll('.ils-pcm__pip');
          if (pips.length) {
            pips[cur % pips.length].classList.remove('is-on');
            pips[nxt % pips.length].classList.add('is-on');
          }
        }
      });
    }, 2000);
  }

  function render() {
    var section = document.querySelector('[data-ils-rv-section]');
    if (!section) return;
    var _lbl = section.getAttribute('data-ils-rv-details-label');
    if (_lbl) DETAILS_LABEL = _lbl;
    var railEl = section.querySelector('[data-ils-rv-rail]');
    if (!railEl) return;

    var currentId = null;
    var curEl = document.querySelector('[data-ils-rv-current]');
    if (curEl) {
      try { currentId = JSON.parse(curEl.textContent).id; } catch (e) {}
    }

    var hist = readHistory().filter(function (p) {
      return String(p.id) !== String(currentId);
    });
    if (!hist.length) {
      section.hidden = true;
      return;
    }

    hist = hist.slice(0, MAX_SHOWN);

    /* Resolve every card in the CURRENT locale (async), preserving order. */
    Promise.all(hist.map(resolveProduct)).then(function (models) {
      var cards = [];
      models.forEach(function (m) {
        if (m && m.title && m.url) cards.push(cardMarkup(m));
      });
      if (!cards.length) {
        section.hidden = true;
        return;
      }
      railEl.innerHTML = cards.join('');
      section.hidden = false;
      section.classList.add('is-ready');
      startAutoplay(railEl);
    });
  }

  function boot() {
    recordCurrent();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
